import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const StyledBreadcrumbs = styled(MuiBreadcrumbs)({
  position: 'relative',
  zIndex: 1,
});

export const StyledBreadcrumbLink = styled(Link)({
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
  },
});

export const StyledBreadcrumbLinkText = styled(Typography)(({ theme }) => ({
  color: theme.palette.info.main,
}));
